import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { TextField, Button, Box, Typography } from '@mui/material';
import GoogleSignInButton from './GoogleSignInButton';
import { requestRegister } from '../../redux/accountSlice';
import { getPasswordErrors } from '../../shared/utils.js';

const FormContainer = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
}));

const Divider = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  color: theme.palette.text.secondary,
  '&::before, &::after': {
    content: '""',
    flex: 1,
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: theme.spacing(0, 1),
  },
}));

const SignUpForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const passwordErrors = getPasswordErrors(password);
  const passwordHasError = password.length > 0 && passwordErrors.length > 0;
  
  const passwordsMatch = password === confirmPassword;
  
  const account = useSelector(state => state.account);
  const dispatch = useDispatch();

  const handleEmailSignUp = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert('As senhas não coincidem!');
      return;
    }
    dispatch(requestRegister({ name, email, password, passwordConfirmation: confirmPassword }));
  };

  return (
    <>
      
      {!account.isEmailSent && (
        <>
          <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 2 }}>Cadastrar</Typography>
          <GoogleSignInButton />
          <Divider variant="body2" sx={{ my: 1 }}>ou</Divider>
          <FormContainer onSubmit={handleEmailSignUp}>
            <TextField
              fullWidth
              label="Nome"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required />
            <TextField
              fullWidth
              label="E-mail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required />
            <Box>
              <TextField
                fullWidth
                label="Senha"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required 
                error={passwordHasError}
                helperText={passwordHasError ? `Falta: ${passwordErrors.join(', ')}` : ''}/>
            </Box>
            <TextField
              fullWidth
              label="Confirme a Senha"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required 
              error={confirmPassword.length > 0 && !passwordsMatch}
              helperText={confirmPassword.length > 0 && !passwordsMatch ? 'As senhas não coincidem.' : ''}
            />
            <Button
              fullWidth
              variant="contained"
              type="submit"
              size="large"
              sx={{ mt: 2 }}
              disabled={passwordErrors.length > 0 || !passwordsMatch}
            >
              Cadastrar
            </Button>
          </FormContainer>
        </>
      )}
      {account.isEmailSent && ( 
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h5" component="h1" gutterBottom>
          Quase lá!
        </Typography>
        <Typography>
          Um link de verificação foi enviado para o seu e-mail. Por favor, verifique sua caixa de entrada para ativar sua conta.
        </Typography>
      </Box>
    )}
    </>
  );
};

export default SignUpForm;
